{
  "$id": "wealthlane://forms/share-pool/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "share_pool_identity",
      "fields": [
        {
          "scope": "#/properties/poolName",
          "field": "#/properties/poolName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 280,
          "maxWidthPx": 800
        },
        {
          "scope": "#/properties/poolTypeId",
          "field": "#/properties/poolTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        }
      ]
    },
    {
      "rowId": "share_pool_counts",
      "fields": [
        {
          "scope": "#/properties/numberOfSharesAuthorised",
          "field": "#/properties/numberOfSharesAuthorised",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280,
          "startNewRow": true
        },
        {
          "scope": "#/properties/numberOfSharesUnAvailable",
          "field": "#/properties/numberOfSharesUnAvailable",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/numberOfSharesAvailable",
          "field": "#/properties/numberOfSharesAvailable",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/eligibleShareClass",
          "field": "#/properties/eligibleShareClass",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/stockClassId",
          "field": "#/properties/stockClassId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/description",
          "field": "#/properties/description",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "startNewRow": true
        },
        {
          "scope": "#/properties/hasExternalPoolRefrence",
          "field": "#/properties/hasExternalPoolRefrence",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "startNewRow": true,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        },
        {
          "scope": "#/properties/externalPoolReferenceId",
          "field": "#/properties/externalPoolReferenceId",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 240,
          "maxWidthPx": 480,
          "startNewRow": true
        }
      ]
    }
  ]
}
